const currentURL = window.location.href
const pathname = window.location.pathname
const updatedPathname = pathname.substring(1)
const inquireToPurchaseButton = document.querySelector(
  '.contact-to-inquire__wrapper'
)
const variantButtons = document.querySelectorAll('.vp__input label')

if (currentURL.includes('/products/')) {
  sessionStorage.removeItem('inquireToPurchaseProductURL')
  sessionStorage.removeItem('inquireToPurchaseProductTitle')
  sessionStorage.removeItem('inquireToPurchaseProductVariant')
}

if (inquireToPurchaseButton != null) {
  fetch(window.Shopify.routes.root + updatedPathname + '.js')
    .then((response) => response.json())
    .then((product) => setItem(product))
    .then(() => addVariantButtonListeners())
}

function getVariant(product, variantToFind) {
  const variant = product.variants.find((v) => v.id == variantToFind)
  return variant ? variant.title : null
}

function setItem(product) {
  const inquireToPurchaseProductURL = currentURL
  const inquireToPurchaseProductTitle = product.title
  const variantToFind = currentURL.split('variant=').pop()
  const inquireToPurchaseProductVariant =
    getVariant(product, variantToFind) ||
    document.querySelector('hh-variant-picker input[checked]')?.value

  sessionStorage.setItem(
    'inquireToPurchaseProductURL',
    inquireToPurchaseProductURL
  )
  sessionStorage.setItem(
    'inquireToPurchaseProductTitle',
    inquireToPurchaseProductTitle
  )
  if (inquireToPurchaseProductVariant) {
    sessionStorage.setItem(
      'inquireToPurchaseProductVariant',
      inquireToPurchaseProductVariant
    )
  }
}

function addVariantButtonListeners() {
  variantButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const variantTitle = button.textContent
        .replace(/[\n\r]+|[\s]{2,}/g, ' ')
        .trim()
      if (variantTitle) {
        sessionStorage.setItem('inquireToPurchaseProductVariant', variantTitle)
      }
    })
  })
}

if (
  currentURL.includes('/pages/contact') &&
  sessionStorage.getItem('inquireToPurchaseProductURL')
) {
  const formComment = document.getElementById('ContactForm-body')

  const inquireToPurchaseProductTitle = sessionStorage.getItem(
    'inquireToPurchaseProductTitle'
  )
  const inquireToPurchaseProductVariant = sessionStorage.getItem(
    'inquireToPurchaseProductVariant'
  )

  if (inquireToPurchaseProductVariant) {
    formComment.value = `I am interested in ${inquireToPurchaseProductTitle} in ${inquireToPurchaseProductVariant}.`
  } else {
    formComment.value = `I am interested in ${inquireToPurchaseProductTitle}.`
  }
}
